import DeleteMixin from "./DeleteMixin";

export default {
    mixins: [DeleteMixin],
}
